import { Paper, Stack, Text } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { DebtorSummary } from "types/model.types";

interface DebtorCardProps {
  d: DebtorSummary;
  onClose?: () => void;
}

const DebtorCard: React.FC<DebtorCardProps> = ({ d, onClose }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/admin/enquire-debtors?id=${d.id}`);
    onClose && onClose?.();
  };

  return (
    <Paper
      withBorder
      radius="md"
      p="md"
      shadow="sm"
      onClick={handleClick}
      style={{
        display: "flex",
        flexDirection: "row",
        gap: "2rem",
        width: "100%",
        cursor: "pointer",
        transition: "background 120ms ease",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.background = "#f8f9fa")}
      onMouseLeave={(e) => (e.currentTarget.style.background = "white")}
    >
      {/* Column 1 */}
      <Stack gap={4} style={{ flex: 1 }}>
        <Text fw={600} size="sm">
          {d.name}
        </Text>
        <Text size="sm">ID: {d.id}</Text>
        <Text size="sm">
          Active:
          <Text span fw={600} c={d.active ? "green" : "red"}>
            {d.active ? " Yes" : " No"}
          </Text>
        </Text>
      </Stack>

      {/* Column 2 */}
      <Stack gap={4} style={{ flex: 1 }}>
        <Text size="sm">Primary Address:</Text>
        <Text size="sm" c="dimmed">
          {d.primaryAddress}
        </Text>
        <Text size="sm">Delivery Address:</Text>
        <Text size="sm" c="dimmed">
          {d.deliveryAddress}
        </Text>
      </Stack>

      {/* Column 3 */}
      <Stack gap={4} style={{ flex: 1 }}>
        <Text size="sm">Phone: {d.phone}</Text>
        <Text size="sm">Attn1: {d.attn1}</Text>
        <Text size="sm">Attn2: {d.attn2}</Text>
        <Text size="sm">Email: {d.email}</Text>
      </Stack>
    </Paper>
  );
};

export default DebtorCard;
